import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  apiFinancialCalc,
  FinancialCalcReq,
  FinancialCalcRes,
  FinancialCalcResult,
} from '../../api/selfApi'

export const RESTYPE_TARGET = 'target'
export const RESTYPE_INTEREST = 'interest'
export const RESTYPE_MONTHS = 'months'
export const RESTYPE_ADDITION = 'addition'

export interface FinancialCalcResults {
  target: FinancialCalcResult | undefined
  interest: FinancialCalcResult | undefined
  months: FinancialCalcResult | undefined
  addition: FinancialCalcResult | undefined
}

export interface FinancialCalcState {
  result: FinancialCalcResults
  responseCode: number
  fetchingRestype: 'target' | 'interest' | 'months' | 'addition'
  fetchState: 'initialize' | 'pending' | 'fulfilled' | 'rejected'
}

export const initialState: FinancialCalcState = {
  result: {
    target: undefined,
    interest: undefined,
    months: undefined,
    addition: undefined,
  },
  responseCode: 0,
  fetchingRestype: RESTYPE_TARGET,
  fetchState: 'initialize',
}

// TODO ApiのstatusCodeによるエラー処理など
export const fetchFinancialCalc = createAsyncThunk<FinancialCalcRes, FinancialCalcReq>(
  'financialCalc/fetchApi',
  async (arg) => {
    const response = await apiFinancialCalc(arg)
    return response.payload
  }
)

export const financialCalc = createSlice({
  name: 'financialCalc',
  initialState,
  reducers: {
    reset: (state) => {
      state.result = initialState.result
      state.fetchState = initialState.fetchState
      state.responseCode = initialState.responseCode
    },
    changeFetchingRestype: (
      state,
      action: PayloadAction<'target' | 'interest' | 'months' | 'addition'>
    ) => {
      state.fetchingRestype = action.payload
    },
    fetchMock: (state, action) => {
      const result = {
        principal: 1720000,
        amount: 1720275,
        depositAmount: 1720100,
        addition: 30000,
        depositAddition: 30000,
        interest: 0,
        months: 24,
        depositMonths: 24,
        monthList: _monthList,
        principalList: _principalList,
        profitList: _profitList,
        amountList: _amountList,
      } as FinancialCalcResult
      switch (state.fetchingRestype) {
        case RESTYPE_TARGET:
          state.result.target = result
          break
        case RESTYPE_ADDITION:
          state.result.addition = result
          break
        case RESTYPE_INTEREST:
          state.result.interest = result
          break
        case RESTYPE_MONTHS:
          state.result.months = result
          break
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchFinancialCalc.pending, (state, action) => {
      state.fetchState = 'pending'
    })
    builder.addCase(fetchFinancialCalc.fulfilled, (state, action) => {
      state.fetchState = 'fulfilled'
      state.responseCode = action.payload.statusCode
      switch (state.fetchingRestype) {
        case RESTYPE_TARGET:
          state.result.target = action.payload.result
          break
        case RESTYPE_ADDITION:
          state.result.addition = action.payload.result
          break
        case RESTYPE_INTEREST:
          state.result.interest = action.payload.result
          break
        case RESTYPE_MONTHS:
          state.result.months = action.payload.result
          break
      }
    })
    builder.addCase(fetchFinancialCalc.rejected, (state, action) => {
      state.fetchState = 'rejected'
      state.responseCode = 20
      switch (state.fetchingRestype) {
        case RESTYPE_TARGET:
          state.result.target = undefined
          break
        case RESTYPE_ADDITION:
          state.result.addition = undefined
          break
        case RESTYPE_INTEREST:
          state.result.interest = undefined
          break
        case RESTYPE_MONTHS:
          state.result.months = undefined
          break
      }
    })
  },
})
export const { reset, fetchMock, changeFetchingRestype } = financialCalc.actions

// mockData
const _monthList = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
]
const _principalList = [
  1030000, 1060000, 1090000, 1120000, 1150000, 1180000, 1210000, 1240000, 1270000, 1300000, 1330000,
  1360000, 1390000, 1420000, 1450000, 1480000, 1510000, 1540000, 1570000, 1600000, 1630000, 1660000,
  1690000, 1720000,
]
const _profitList = [
  9, 17, 26, 36, 45, 55, 65, 76, 86, 97, 108, 119, 131, 143, 155, 167, 180, 193, 206, 219, 233, 247,
  261, 275,
]
const _amountList = [
  1030009, 1060017, 1090026, 1120036, 1150045, 1180055, 1210065, 1240076, 1270086, 1300097, 1330108,
  1360119, 1390131, 1420143, 1450155, 1480167, 1510180, 1540193, 1570206, 1600219, 1630233, 1660247,
  1690261, 1720275,
]
